// extracted by mini-css-extract-plugin
module.exports = {"container":"PauseDripModal_container__12yTT","primaryText":"PauseDripModal_primaryText__3jAPM","footer":"PauseDripModal_footer__3fJc0"};